/* eslint-disable @typescript-eslint/restrict-plus-operands */
import {environment} from '../config/environment'

export const API = {
  cloudManager: environment().cloudManager_base_Url + 'ipa/account/',
  generateToken: environment().cmAccess_tokeBase_url + 'v1/token/cloud-manager/generate?',
  customerList: environment().public_api_url + 'v1/system/list/level/customer',
  userInfo: environment().public_api_url + 'v1/user2/info',
}
